var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWidgetInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#AEB1C8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  d: "M20 1.563c10.183 0 18.437 8.254 18.437 18.437 0 3.65-1.06 7.05-2.89 9.913l2.89 8.524-8.524-2.889A18.35 18.35 0 0 1 20 38.438C9.817 38.438 1.562 30.182 1.562 20 1.563 9.817 9.818 1.563 20 1.563m0 9.375v11.874M20 28v1"
})));
export default SvgWidgetInfo;